<template v-cloak>
  <Loading v-if="loading" :activated="true" />
  <div v-else>
    <div class="columns">
      <div class="column-left rte">
        <p>{{ this.$attrs.welcome_msg }}</p>
        <p v-if="!isLoading && variants.length === 0">{{ this.$attrs.empty_msg }}</p>
      </div>

      <div class="column-right rte" v-if="!isLoading && variants.length === 0">
        <a href="/" class="btn with-arrow btn-wide">{{ this.$attrs.browsing_msg }}</a>
      </div>
    </div>
    <div v-show="variants.length !== 0">
      <div class="wardrobe-grid" v-if="variants.length !== 0">
        <div class="wardrobe-item" v-for="(node, k) in variants" :key="k" @click="toProduct(node)">
          <div class="product-image">
            <transition name="fade">
              <VImg
                v-show="node.image"
                :media="node.image"
                fixedSize="550x"
                class="product-item__main-img"
                :customClass="{ lazyload: true, 'remove-transition': 1 }" />
            </transition>
          </div>
          <div class="product-text">
            <p class="title">{{ node.product.title }}</p>
            <p v-show="node.product.vendor" class="vendor">{{ node.product.vendor }}</p>
            <p v-show="node.size" class="size">{{ node.size }}</p>
          </div>
        </div>
      </div>
      <a
        href="#"
        class="wardrobe-load-more link-underline"
        v-if="current_page < total_page"
        @click="loadMore"
        :disabled="isLoading">
        {{ this.$attrs.loadmore_msg }}
      </a>
    </div>
  </div>
</template>

<script>
import Loading from './Loading'
import VImg from './VImg'
import { FETCH_VARIANTS as QUERY } from '../../scripts/queries'

export default {
  name: 'Wardrobe',
  props: {
    products: { type: Array, required: true, default: [] },
    loading: { type: Boolean, requried: true },
    current_page: { type: Number, required: true },
    total_page: { type: Number, required: true },
    items: { type: Array, default: () => [] },
    ids: { type: Array, default: () => [] }
  },
  data: () => ({
    isLoading: true,
    queryIds: [],
    variants: []
  }),
  components: { Loading, VImg },
  watch: {
    products: function (v) {
      if (v.length === 0) {
        this.isLoading = false
        return
      }
      let vids = v.filter((val) => this.queryIds.indexOf(val.vid) === -1)
      vids = vids.map((v) => {
        this.queryIds.push(v.vid)
        return btoa(`gid://shopify/ProductVariant/${v.vid}`)
      })
      this.$gql
        .post('/api/2023-07/graphql.json', JSON.stringify({ query: QUERY, variables: { vids } }))
        .then(({ data }) => {
          data.data.nodes.forEach((node) => {
            let size_option = node.selectedOptions.find((val) => val.name === 'size')
            node['size'] = size_option || null
            this.variants.push(node)
            this.$emit('change', { items: this.variants, ids: this.queryIds })
          })
          this.isLoading = false
        })
    }
  },
  methods: {
    loadMore: function () {
      this.isLoading = true
      this.$emit('loadmore')
    },
    toProduct: function (node) {
      window.open(`/products/${node.product.handle}`)
    }
  },
  mounted: function () {
    this.queryIds = this.ids
    this.variants = this.items
  }
}
</script>
